var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "#D8C8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M676.841 382.472L744.9 321.382C744.9 321.382 741.433 316.583 739.315 313.994C612.99 159.434 388.244 174.05 310.096 341.176C260.029 457.062 358.372 526.27 402.527 544.866C453.054 566.154 466.698 569.817 528.171 585.042C610.134 604.948 640.294 667.279 560.811 687.568C526.425 696.343 457.631 677.525 427.355 661.265C376.076 633.739 352.737 611.264 352.737 611.264L273.711 682.801C273.711 682.801 275.871 685.692 278.889 689.486C399.664 841.476 594.622 844.989 678.938 768.562C726.374 731.492 773.171 653.273 749.446 578.002C741.781 553.722 711.143 486.376 619.393 460.715C580.149 449.741 507.305 437.949 496.865 436.038C401.273 418.551 416.589 242.738 676.841 382.472Z",
    fill: "#1E1E1E",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.095 758.755C360.777 764.312 365.878 767.446 367.641 768.594C367.641 768.594 389.469 781.156 403.035 787.071L408.516 789.572L406.943 649.315C383.709 635.921 361.08 618.182 354.093 611.704L354.055 614.641L353.095 758.755Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.015 757.879L351.193 611.99L298.028 660.652L297.702 710.979C311.925 727.124 332.537 744.664 352.015 757.879Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.149 814.682V685.1C440.339 672.914 418.057 655.456 406.946 649.312L408.52 789.569C429.871 799.542 463.459 810.547 499.149 814.682Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M592.432 810.657C598.692 809.294 612.21 805.432 623.862 801.168C623.862 801.168 639.307 795.165 645.55 791.459L645.609 661.652L602.715 662.931C599.719 667.013 595.344 670.817 592.432 673.339L592.432 810.657Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M647.798 662.527L648.054 789.66C659.341 783.745 672.306 773.895 679.925 767.059L679.216 664.515L647.798 662.527Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M497.041 440.268L497.55 576.429C501.523 577.536 505.644 578.6 510.372 579.724L510.551 454.267L521.852 457.892L522.031 582.591C529.327 584.484 528.301 584.091 533.981 586.381L533.925 461.348L544.379 464.893L544.4 588.77C549.075 590.273 553.898 592.36 557.207 593.775V458.879C527.967 449.763 517.036 446.37 497.041 440.268Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M510.579 287.924C510.629 288.718 510.66 290.344 510.678 291.711H501.278C499.799 291.711 498.597 293.976 498.597 296.773C498.597 297.918 498.538 307.869 498.587 310.174L498.569 328.187C514.082 326.648 533.77 327.966 556.646 333.059L557.025 310.061C557.109 309.078 557.025 297.791 557.025 296.773C557.025 293.976 555.757 292.469 554.352 291.711H544.635C544.635 290.277 544.635 288.546 544.635 287.699C544.639 274.867 535.917 272.422 535.917 272.422L536.349 207.475C530.858 207.254 524.767 207.226 519.003 207.254L519.807 271.769C519.811 271.776 509.968 276.395 510.579 287.924Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M534.153 816.726L534.701 689.603C530.528 689.445 526.197 689.27 521.76 688.781L521.946 816.392C527.405 816.68 529.818 816.821 534.153 816.726Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M510.772 815.788L510.389 687.243C506.617 686.638 502.964 685.873 499.149 685.103L498.471 814.604C504.186 815.184 505.809 815.458 510.772 815.788Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M377.211 649.906L368.464 647.022V652.948L377.211 655.635V649.906Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M377.06 676.395L368.313 673.511V679.437L377.06 682.124V676.395Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M377.06 702.885L368.313 700.001V705.927L377.06 708.614V702.885Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M377.06 732.589L368.313 729.705V735.631L377.06 738.318V732.589Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M377.06 761.063L368.313 758.176V764.105L377.06 766.792V761.063Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M394.261 656.636L385.515 653.752V659.678L394.261 662.365V656.636Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M394.184 683.572L385.438 680.688V686.614L394.184 689.301V683.572Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M394.184 710.507L385.438 707.624V713.55L394.184 716.237V710.507Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M394.184 740.956L385.438 738.072V743.998L394.184 746.685V740.956Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M394.184 768.749L385.438 765.865V771.791L394.184 774.478V768.749Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447.009 710.592V691.967L435.874 688.584V707.543L447.009 710.592Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M446.222 733.66V720.241L435.086 716.736V730.425L446.222 733.66Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M445.829 760.202V746.776L434.693 743.271V756.963L445.829 760.202Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M445.439 783.594V770.171L434.303 766.666V780.358L445.439 783.594Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M471.644 741.859V728.437L460.508 724.931V738.62L471.644 741.859Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M471.644 768.454V755.032L460.508 751.529V765.215L471.644 768.454Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.644 791.905V778.486L460.508 774.98V788.67L471.644 791.905Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M471.791 718.734V700.113L460.656 696.355V715.292L471.791 718.734Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M657.278 587.78V575.735V482.559L605.549 466.583V600.345L643.595 584.769L645.343 584.531H647.003L657.278 587.78Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M626.429 487.167L617.915 484.42V500.905L626.429 503.631V487.167Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M644.913 493.005L636.398 490.258V506.743L644.913 509.469V493.005Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M626.429 513.513L617.915 510.766V527.251L626.429 529.977V513.513Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M644.913 519.351L636.398 516.604V533.086L644.913 535.818V519.351Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M626.429 539.858L617.915 537.115V553.593L626.429 556.326V539.858Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M644.913 545.696L636.398 542.953V559.431L644.913 562.164V545.696Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M626.429 566.204L617.915 563.46V579.939L626.429 582.671V566.204Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M644.913 572.042L636.398 569.298L636.398 587.732L644.913 584.198V572.042Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M658.16 676.571L664.251 678.622V687.794L658.16 685.883V676.571Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M658.16 699.109L664.251 701.16V710.332L658.16 708.421V699.109Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M658.16 722.967L664.251 725.019V734.19L658.16 732.28V722.967Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M658.16 746.826L664.251 748.877V758.049L658.16 756.138V746.826Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M658.16 770.684L664.251 772.736V777.162L658.792 780.193L658.16 779.997V770.684Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M657.563 597.569L663.654 599.621V608.792L657.563 606.881V597.569Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M657.563 620.107L663.654 622.158V631.33L657.563 629.419V620.107Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M657.563 643.966L663.654 646.017V655.189L657.563 653.278V643.966Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M599.564 508.521L562.821 497.168L562.048 595.886C566.084 597.794 569.368 599.761 570.32 600.302L570.623 519.028L575.252 520.454L575.052 603.081C576.531 603.906 580.778 606.762 584.652 609.797L584.649 523.436L589.3 524.788L590.315 614.472C593.694 618.077 592.806 616.731 597.165 621.797C597.411 622.085 598.345 623.184 599.564 624.8V508.985V508.521Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M570.011 518.81L569.572 599.891C572.309 601.633 574.139 602.508 575.449 603.323L575.252 520.457L570.011 518.81Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M584.652 609.801C586.335 611.097 587.961 612.428 589.479 613.812L589.303 524.792L584.652 523.44V609.801Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M546.902 692.756C546.919 809.496 546.783 807.136 546.937 816.736C546.937 816.736 571.636 815.781 592.905 810.491L591.804 705.238L546.902 692.756Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M521.95 816.392L521.764 688.781C518.023 688.374 514.32 687.871 510.39 687.243V815.76C516.168 816.301 517.306 816.392 521.95 816.392Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M546.395 816.392L546.441 689.582C543.336 689.687 537.483 689.708 534.157 689.582L535.857 816.726C542.113 816.726 542.668 816.68 546.395 816.392Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M716.809 655.922L698.711 624.883L696.516 631.347L691.341 648.254L686.086 645.498L686.087 762.239C699.964 749.438 712.873 735.551 726.139 715.326L725.847 659.013L716.809 655.922Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M418.029 483.721V550.189C426.863 553.776 433.963 556.993 449.893 562.442V493.904L418.029 483.721Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M432.094 498.123V508.767L438.037 510.713V500.203L432.094 498.123Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M432.094 518.908V529.548L438.037 531.498V520.988L432.094 518.908Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M432.094 539.693V550.333L438.037 552.283V541.773L432.094 539.693Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M701.121 665.646H696.737V724.246H701.121V665.646Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M714.603 665.646H710.219V724.246H714.603V665.646Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27 422.677L302.315 437.346C307.915 464.043 329.76 495.088 359.945 518.36L361.487 519.365V399.601L358.951 398.228L302.27 422.677Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M418.029 428.81L416.922 428.237L382.297 410.371V349.446H370.67V404.372L361.491 399.598L361.762 519.678C367.045 523.844 370.747 526.31 375.079 529.064C386.565 536.363 397.128 542.015 418.032 550.249L418.029 476.759V431.88V428.81Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M376.083 444.164L385.346 448.938V431.346L376.083 426.709V444.164Z",
    fill: "#FFFDFD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M376.083 479.291L385.346 484.065V466.473L376.083 461.784V479.291Z",
    fill: "#FFFDFD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M394.089 492.148L403.352 496.922V479.565L394.089 474.679V492.148Z",
    fill: "#FFFDFD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M376.125 514.243L385.385 519.017V501.429L376.125 496.736V514.243Z",
    fill: "#FFFDFD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M394.132 527.1L403.391 531.874V514.517L394.132 509.635V527.1Z",
    fill: "#FFFDFD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M394.089 457.691L403.352 462.469V444.877L394.089 440.24V457.691Z",
    fill: "#FFFDFD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M457.414 449.103V437.851L444.297 434.019L444.455 444.926L426.294 439.33L426.684 486.485L449.897 493.904L450.399 562.593C453.859 563.857 455.861 564.528 458.278 565.283L458.52 460.164L462.247 461.289L461.45 566.274C463.083 566.769 466.083 567.865 469.997 568.965L469.603 452.893L457.414 449.103Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M445.997 471.166L434.188 467.38V456.732L445.997 460.319V471.166Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M569.752 714.076H563.32V722.265H569.752V714.076Z",
    fill: "#FCFAFA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M584.157 716.711H577.726V724.899H584.157V716.711Z",
    fill: "#FCFAFA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M584.157 743.306H577.726V751.494H584.157V743.306Z",
    fill: "#FCFAFA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M584.157 769.901H577.726V778.089H584.157V769.901Z",
    fill: "#FCFAFA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M584.157 796.5H577.726V804.688H584.157V796.5Z",
    fill: "#FCFAFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M569.752 739.544H563.32V747.732H569.752V739.544Z",
    fill: "#FCFAFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M569.752 765.011H563.32V773.199H569.752V765.011Z",
    fill: "#FCFAFA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M569.752 791.027H563.32V799.215H569.752V791.027Z",
    fill: "#FCFAFA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M645.474 661.646L644.919 584.764L605.578 599.904L605.182 633.806C607.485 639.164 608.396 644.352 607.92 649.483C607.844 650.316 607.742 651.153 607.579 651.98C606.486 657.531 604.477 661.006 603.137 662.917L645.474 661.646Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M647.293 662.917L675.044 664.336V594.438L647.293 585.432V662.917Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M632.145 683.006L623.177 687.587L623.173 679.764L632.057 675.064L632.145 683.006Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M615.983 691.293L607.022 695.877L607.018 688.054L615.898 683.347L615.983 691.293Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M632.222 706.099L623.258 710.68L623.254 702.857L632.135 698.157L632.222 706.099Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M616.064 714.389L607.099 718.97V711.147L615.976 706.436L616.064 714.389Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M632.222 728.514L623.261 733.091L623.254 725.265L632.135 720.564L632.222 728.514Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M616.067 736.8L607.099 741.378V733.555L615.976 728.851L616.067 736.8Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M632.222 749.836L623.258 754.413L623.254 746.598L632.138 741.894L632.222 749.836Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M616.064 758.126L607.099 762.707L607.103 754.881L615.979 750.177L616.064 758.126Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M632.219 770.653L623.258 775.23L623.254 767.411L632.135 762.707L632.219 770.653Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M616.064 778.94L607.099 783.517V775.697L615.976 770.994L616.064 778.94Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M314.789 669.194L307.086 672.503V664.645L314.789 661.333V669.194Z",
    fill: "#F9F7F7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M328.71 661.333L321.007 664.645V656.78L328.71 653.475V661.333Z",
    fill: "#F9F7F7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M328.71 677.056L321.007 680.368V672.503L328.71 669.194V677.056Z",
    fill: "#F9F7F7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M328.71 692.793L321.007 696.109V688.247L328.71 684.935V692.793Z",
    fill: "#F9F7F7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M328.71 708.466L321.007 711.772V703.914L328.71 700.605V708.466Z",
    fill: "#F9F7F7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M328.71 724.19L321.007 727.495V719.637L328.71 716.325V724.19Z",
    fill: "#F9F7F7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 653.162L334.995 656.471V648.613L342.695 645.304V653.162Z",
    fill: "#F9F7F7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 669.194L334.995 672.503V664.645L342.695 661.333V669.194Z",
    fill: "#F9F7F7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 684.935L334.995 688.247V680.386L342.695 677.077V684.935Z",
    fill: "#F9F7F7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 700.658L334.995 703.967V696.109L342.695 692.793V700.658Z",
    fill: "#F9F7F7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 716.325L334.995 719.637V711.772L342.695 708.467V716.325Z",
    fill: "#F9F7F7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M342.695 731.046L334.995 734.356V726.494L342.695 723.188V731.046Z",
    fill: "#F9F7F7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M314.789 684.935L307.086 688.247V680.386L314.789 677.077V684.935Z",
    fill: "#F9F7F7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M314.789 700.742L307.086 704.051V696.19L314.789 692.881V700.742Z",
    fill: "#F9F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.928e7ba896b4fb87e941f8feccdb7b5c.svg";
export { ForwardRef as ReactComponent };